export default __webpack_public_path__ + "static/media/maintenance-icon.8dd8315f.svg";